import { API } from "aws-amplify";
import { useContext } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import RuleForm from "components/rules/RuleForm";
import { createRule, createRuleDevice } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const RuleCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const rule = {
    name: "",
    description: "",
    action: "",
    actionValue: "",
    devices: [],
    smsNotifications: [],
    wspNotifications: [],
    emailNotifications: [],
    conditions: [],
    companyID: me.companyID ?? "",
    startSchedule: "",
    endSchedule: "",
    days: [],
    execInterval: "hour",
    execTime: "",
    hourInterval: null,
    executeOnHolidays: false,
  };

  async function onSubmit(values) {
    try {
      const {
        name,
        description,
        action,
        actionValue,
        devices,
        smsNotifications,
        wspNotifications,
        emailNotifications,
        conditions,
        companyID,
        startSchedule,
        endSchedule,
        days,
        execInterval,
        execTime,
        hourInterval,
        executeOnHolidays,
      } = values;

      const rule = (
        await API.graphql({
          query: createRule.replaceAll("__typename", ""),
          variables: {
            input: {
              name,
              description,
              action,
              actionValue,
              smsNotifications,
              wspNotifications,
              emailNotifications,
              conditions: JSON.stringify(conditions),
              companyID,
              startSchedule,
              endSchedule,
              days,
              execInterval,
              execTime,
              hourInterval,
              executeOnHolidays,
              enabled: true,
            },
          },
        })
      )?.data?.createRule;

      const promises = [];

      promises.push(
        ...devices.reduce((promises, device) => {
          promises.push(
            API.graphql({
              query: createRuleDevice.replaceAll("__typename", ""),
              variables: {
                input: {
                  ruleId: rule.id,
                  deviceId: device.id,
                },
              },
            })
          );
          return promises;
        }, [])
      );

      await Promise.all(promises);

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/rules");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <RuleForm onSubmit={onSubmit} initialValues={rule} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Regla",
    successAdded: "Regla agregada con éxito",
    responses: {},
  },
});

export default RuleCreateForm;
